<template lang="html">

  <span v-bind:class="'slds-icon_container slds-icon-utility-'+name" title="Description of icon when needed">
    <svg class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
      <use v-bind:xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+name"></use>
    </svg>
    <span class="slds-assistive-text">Description of icon when needed</span>
  </span>

</template>

<script>

export default {
  name: 'progressbar',
  components: {
  },
  computed: {
  },
  props: {
    name: String
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
</style>
